export const styles = {
  item: {
    p: 0,
    position: "relative",
    mb: "1.125rem",
    cursor: "pointer",
    "&:hover": {
      "& .MuiBox-root": {
        opacity: 1,
      },
      "& .MuiIconButton-root": {
        opacity: 1,
      },
    },
  },
  actions: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    left: "-34px",
    bottom: "48px",
  },
  icon: {
    width: "1.5rem",
    height: "1.5rem",
    color: "white",
    backgroundColor: "events.blueSecondary",
    borderRadius: "50%",
    mt: "1rem",
    transition: "opacity 200ms ease-in-out 100ms",
    opacity: 0,
    boxShadow: "2.4px 2.4px 2.4px 0px #0c38911a",
    "& button": {
      p: "2px",
      color: "inherit",
      "&.Mui-disabled": {
        color: "var(--LightGrey)",
      },
    },
    "& button > svg": {
      width: "100%",
      height: "100%",
      color: "inherit",
    },
  },
  deleteIcon: {
    p: 0,
    width: "1.5rem",
    opacity: 0,
    "&.Mui-disabled": {
      color: "var(--LightGrey)",
    },
    color: "events.blueSecondary",
    mt: 0,
    position: "absolute",
    top: "15px",
    right: "25px",
    transition:
      "opacity 200ms ease-in-out 100ms, transform 150ms ease-in-out 100ms",
    borderRadius: "4px",
    height: "1.5rem",
    svg: {
      width: "1.25rem",
      height: "1.25rem",
    },
  },
};
